import { render, staticRenderFns } from "./TeachThink.vue?vue&type=template&id=476cc3ee&scoped=true&"
import script from "./TeachThink.vue?vue&type=script&lang=js&"
export * from "./TeachThink.vue?vue&type=script&lang=js&"
import style0 from "./TeachThink.vue?vue&type=style&index=0&id=476cc3ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476cc3ee",
  null
  
)

export default component.exports